import moment from 'moment/moment';
import {
  IAreaMeterAllReadings,
  IHouseMeter,
} from '../store/models/metersStore';
import coldWaterIcon from '../assets/icons/meters/cold-water.svg';
import hotWaterIcon from '../assets/icons/meters/hot-water.svg';
import heatIcon from '../assets/icons/meters/heat-meter.svg';
import electricIcon from '../assets/icons/meters/electric.svg';
import gasIcon from '../assets/icons/meters/gas.svg';
import { IConstant } from '../types';
import { getConstantName } from './common-utils';

/* Форматирует данные показаний счётчиков */
export const getReading = (value: number): string => {
  return value.toString();
};

/* Проверяет, является ли счётчик архивным */
export const isArchiveMeter = (
  nextCheckDate: string,
  workingFinishDate: string | null = null
): boolean => {
  const now = moment();

  if (workingFinishDate !== null && moment(workingFinishDate).isBefore(now)) {
    return true;
  }

  const meterNextCheckDate = moment(nextCheckDate).add(6, 'M');

  return now.isAfter(meterNextCheckDate);
};

/* Возвращает true, если срок поверки меньше заданного количества месяцев */
export const checkDate = (date: string, monthCount: number): boolean => {
  const nowPlusMonthCount = moment().add(monthCount, 'M');
  const meterCheckDate = moment(date);
  return nowPlusMonthCount.isAfter(meterCheckDate);
};

/* Возвращает true, если последние показания более, чем три месяца назад */
export const checkLastReadings = (date: string): boolean => {
  const lastReadings = moment(date);
  const nowMinusThreeMonth = moment().subtract(3, 'M');
  return nowMinusThreeMonth.isAfter(lastReadings);
};

export const getMeterIcon = (meterType: string): string => {
  switch (meterType) {
    case 'ColdWaterAreaMeter':
      return coldWaterIcon;
    case 'HotWaterAreaMeter':
      return hotWaterIcon;
    case 'HeatAreaMeter':
      return heatIcon;
    case 'ElectricOneRateAreaMeter':
    case 'ElectricTwoRateAreaMeter':
    case 'ElectricThreeRateAreaMeter':
      return electricIcon;
    case 'GasAreaMeter':
      return gasIcon;
    default:
      return '';
  }
};

export const isMultiMeter = (meterType: string): boolean => {
  return ['ElectricTwoRateAreaMeter', 'ElectricThreeRateAreaMeter'].includes(
    meterType
  );
};

/* Формирование описания заявки на замену счётчиков */
export const generateMeterReplacementDescription = (
  meters: IAreaMeterAllReadings[],
  meterTypeConstants: IConstant[],
  areaLocationsConstants: IConstant[]
) => {
  let description = 'Требуется произвести замену ИПУ:\n';

  meters.forEach((meter) => {
    const meterName = getConstantName(meterTypeConstants, meter.type);
    const meterMounting = getConstantName(
      areaLocationsConstants,
      meter.mounting || ''
    );

    description += `${meterName} №${meter.serial_number}${
      meterMounting ? ` (${meterMounting})` : ''
    } истёк срок поверки\n`;
  });

  return description;
};

// Проверяет, является ли счетчик ненастроенным
export const isConfiguredMeter = (meter: IHouseMeter) => {
  return (
    !!meter.meter_model &&
    !!meter.temperature_chart &&
    !!meter.heat_systems.length
  );
};
